import { useState, useEffect } from 'react';
import LoginForm from '../components/LoginForm';
import CheckinForm from '../components/CheckinForm';

const CheckinPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [employeeData, setEmployeeData] = useState<{
    id: string;
    name: string;
    recoveryCode: string;
  } | null>(null);

  useEffect(() => {
    // Check for stored login data
    const storedData = localStorage.getItem('employeeData');
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData && parsedData.id && parsedData.name && parsedData.recoveryCode) {
          setEmployeeData(parsedData);
          setIsLoggedIn(true);
        }
      } catch (error) {
        console.error('Error parsing stored login data:', error);
        localStorage.removeItem('employeeData');
      }
    }
  }, []);

  const handleLogin = (data: { id: string; name: string; recoveryCode: string }) => {
    setIsLoggedIn(true);
    setEmployeeData(data);
    // Store login data
    localStorage.setItem('employeeData', JSON.stringify(data));
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setEmployeeData(null);
    // Clear stored data
    localStorage.removeItem('employeeData');
    localStorage.removeItem('checkedInToday');
  };

  return (
    <div>
      <h1 className="text-xl sm:text-2xl text-primary text-center font-semibold mb-6 md:mb-8 relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-16 after:h-[3px] after:rounded after:bg-gradient-to-r after:from-blue-500 after:to-blue-700 hidden md:block">
        DEJA Check-in System
      </h1>

      {!isLoggedIn ? (
        <LoginForm onLogin={handleLogin} />
      ) : (
        <CheckinForm employeeData={employeeData!} onLogout={handleLogout} />
      )}
    </div>
  );
};

export default CheckinPage; 